import { takeEvery, takeLatest, fork, put, all, call, select } from "redux-saga/effects";
import {
    getAdminsError,
    getAdminsSuccessful,
    addAdminError,
    addAdminSuccessful,
    showAddAdminModalSuccess,
    removeAdminError,
    removeAdminSuccess,
    getAdmins,
    editAdminError,
    editAdminSuccess, getStatisticSuccessful, getStatisticError,
    setAdminQuery
} from "./actions";
import AdminService from "./service";
import { AdminActionTypes } from "./actionTypes";

// Selector to get the admin query state from the Redux store.
export const getAdminQuery = state => state.Admin.query;

function* get({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getAdminQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload };
        const response = yield call(AdminService.getAdmins, finalPayload);
        yield put(getAdminsSuccessful(response));
        yield put(setAdminQuery(finalPayload));
    } catch (error) {
        yield put(getAdminsError(error));
    }
}
function* getStatisticData({payload}) {
    try {
        const response = yield call(AdminService.statisticData, payload);
        yield put(getStatisticSuccessful(response));
    } catch (error) {
        yield put(getStatisticError(error));
    }
}
function* addAdmin({ payload: admin }) {
    try {
        const response = yield call(AdminService.addAdmin, admin);
        yield put(addAdminSuccessful(response));
        yield put(getAdmins());

    } catch (error) {
        yield put(addAdminError(error));
    }
}

function* showAddAdmin({ payload: showModal }) {
    yield put(showAddAdminModalSuccess(showModal));
}

function* removeAdmin({ payload: adminId }) {
    try {
        const response = yield call(AdminService.removeAdmin, adminId);
        yield put(removeAdminSuccess(response));
        yield put(getAdmins());
    } catch (error) {
        yield put(removeAdminError(error));
    }
}

function* edit({ payload: admin }) {
    try {
        const response = yield call(AdminService.editAdmin, admin);
        yield put(editAdminSuccess(response));
        yield put(getAdmins());
    } catch (error) {
        yield put(editAdminError(error));
    }
}

export function* watchGetAdmin() {
    yield takeLatest(AdminActionTypes.ADMIN_LIST_GET, get);
}
export function* watchGetAdminStatistic() {
    yield takeEvery(AdminActionTypes.ADMIN_STATISTIC_DATA, getStatisticData);
}
export function* watchAddAdmin() {
    yield takeEvery(AdminActionTypes.ADMIN_ADD, addAdmin);
}

export function* watchShowAddAdminModal() {
    yield takeEvery(AdminActionTypes.ADMIN_ADD_MODAL, showAddAdmin);
}

export function* watchRemoveAdmin() {
    yield takeEvery(AdminActionTypes.ADMIN_REMOVE, removeAdmin);
}

export function* watchEditAdmin() {
    yield takeEvery(AdminActionTypes.ADMIN_EDIT, edit);
}

function* adminsSaga() {
    yield all([
        fork(watchGetAdmin),
        fork(watchAddAdmin),
        fork(watchShowAddAdminModal),
        fork(watchRemoveAdmin),
        fork(watchEditAdmin),
        fork(watchGetAdminStatistic)
    ]);
}

export default adminsSaga;
